import traverseForm from "./traverseForm";

/**
 * Pick random option (move) for given form.
 *
 * If the `form` implies no move, `null` is returned.
 *
 * @param {Form} form - a form that specifies a set of possible moves.
 * @return {*} a random option (move) associated with the form, or null
 */
export default function pickRandomOption(form) {
  return traverseForm(form, () => {}, { randomInput: true, randomSumForm: true }).ind({
    onNoMove() {
      return null;
    },
    onMove(v) {
      return v;
    },
    onPendingMove() {
      throw new Error("This code is unreachable");
    },
  });
}
